import React, { useContext } from 'react'
import { AppContext } from './../providers'
import { Welcome } from './../components'

const Home = () => {
  const { theme } = useContext(AppContext)
  require(`./../css/${theme.homeStyle}`)

  return (
    <div className="demoHome">
      <Welcome style={{ 'position:': 'absolute' }} />
      <div className="Hometext">
        <h1>Welcome!</h1>
        <p>Browse our template catalog to start.</p>
      </div>
    </div>
  )
}

export default Home
